import isNil from 'lodash/isNil'
import isObject from 'lodash/isObject'

import { DataValue } from './types'

export function getFormData<T extends { [key in keyof T]: DataValue }>(
	data: T,
	fieldNames?: { [key in keyof T]: string }
): FormData {
	const formData = new FormData()

	if (fieldNames) {
		Object.keys(data).forEach((key) => {
			const value = data[key as keyof T]

			if (Array.isArray(value)) {
				value.forEach((item: string) => formData.append(fieldNames[key as keyof T], item))
				return
			}

			formData.append(fieldNames[key as keyof T], value as string | Blob)
		})
	} else {
		Object.entries(data).forEach(([key, value]) => {
			if (!isNil(value)) {
				if (Array.isArray(value)) {
					value.forEach((elem, index) => {
						if (isObject(elem)) {
							if ('uid' in elem) {
								formData.append(key, elem as unknown as Blob)
								return
							}

							const formattedKey = `${key}[${index}]`
							const elemEntriesData: [key: string, value: DataValue][] =
								Object.entries(elem)

							elemEntriesData.forEach((entryData) => {
								const [elemKey, elemValue] = entryData
								formData.append(`${formattedKey}.${elemKey}`, elemValue as string)
							})

							return
						}

						formData.append(key, elem)
					})
				} else {
					formData.append(key, value as string | Blob)
				}
			}
		})
	}

	return formData
}
